import { render, staticRenderFns } from "./PurchaseOrderInput.vue?vue&type=template&id=13d2fdf0"
import script from "./PurchaseOrderInput.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports